export default function TimePicker() {
  return {
    MuiTimePicker: {
      defaultProps: {
        desktopModeMediaQuery: '@media (min-width:480px)',
      },
    },
  };
}
